import React from 'react'
import Link from '../../helper/link'
import { connect } from 'react-redux'
import { ApplicationState } from '../../redux/ApplicationState'
import { getNavigationState } from '../../redux/V2/V2State'
import { NavigationContext } from '../SideBarNavigation'

interface OwnProps {
    current?: string
    showTooltip: boolean
    application?: string
    applications: Array<string>
    navigationContext: NavigationContext
}

interface StateProps {
    organizations: Array<string>
    userName: string
    defaultOrganization?: string
    loaded: boolean
}

interface State {
    search: string
}

type Props = OwnProps & StateProps

class OrganizationDropdownComponent extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = { search: '' }
    }

    render() {
        let { organizations } = this.props
        const { current, userName, showTooltip, application, applications, navigationContext, loaded } = this.props
        const { search } = this.state

        const showOrganizationTooltip = showTooltip && 'tw-tooltip tw-tooltip-dataText tw-tooltip--right'

        const showSearchBar = organizations.length > 10
        const anyOrganizations = organizations.length > 0

        if (!loaded) {
            return
        }

        if (search) {
            organizations = organizations.filter(organization => organization.toLowerCase().includes(search.toLowerCase()))
        }

        // current organization to top
        organizations = organizations.sort((a, b) => {
            if (a === current) {
                return -1
            }

            if (b === current) {
                return 1
            }

            if (a === this.props.defaultOrganization) {
                return -1
            }

            return 0
        })

        const secondLineLabel = this.secondLine(application, navigationContext)

        if (!anyOrganizations) {
            return (
                <div className="sideNav-head">
                    <div className="sideNav-logo">
                        <img src="/assets/img/tideways-small.png" alt="Dashboard" width="36" height="36" />
                    </div>
                    <div>Welcome!</div>
                </div>
            )
        }

        return (
            <div className="sideNav-head">
                <a href={'/dashboard?current=' + current} className="sideNav-logo">
                    <img src="/assets/img/tideways-small.png" alt="Dashboard" width="36" height="36" />
                </a>
                <div className="dropdown sideNav-dropdown">
                    <div className="dropdown-toggle" data-toggle="dropdown" id="organization-dropdown">
                        <div className="sideNav-dropdown-wrapper ${showOrganizationTooltip}" data-tooltip-text={current}>
                            <span className="text-ellipsis">
                                {navigationContext === 'user-settings' ? (
                                    <>
                                        <i className="fa fa-user" /> {userName}
                                    </>
                                ) : (
                                    <>{current || 'Settings'}</>
                                )}
                            </span>
                            <i className="fa fa-chevron-down sideNav-dropdown-icon" />
                        </div>
                        {current ? (
                            <div
                                className={`text-ellipsis sideNav-projectname ${showOrganizationTooltip}`}
                                data-tooltip-text={secondLineLabel}
                            >
                                {secondLineLabel}
                            </div>
                        ) : (
                            <div>&nbsp;</div>
                        )}
                    </div>
                    <ul className="dropdown-menu tw-shadow-300" aria-labelledby="organization-dropdown">
                        <li className="dropdown-header">Your Organizations</li>
                        {showSearchBar && (
                            <li>
                                <input
                                    type="text"
                                    value={search}
                                    onChange={ev => this.setState({ search: ev.target.value })}
                                    placeholder="filter"
                                    className="form-control tw-ml-8 tw-mr-8"
                                    style={{ width: 'auto' }}
                                />
                            </li>
                        )}
                        {organizations.map(organization => (
                            <React.Fragment key={organization}>
                                <li className="tw-pl-8">
                                    <Link
                                        route="dashboard"
                                        params={{ current: organization }}
                                        skipHistoryApi
                                        className={organization === current ? 'tw-font-weight-strong' : ''}
                                    >
                                        {organization}
                                    </Link>
                                </li>
                                {organization === current && applications.length > 0
                                    ? applications.map(app => (
                                          <li key={app} className="tw-pl-24">
                                              <Link
                                                  route="XhprofOrganizationBundle.Application.show"
                                                  params={{ organization: current, application: app }}
                                                  skipHistoryApi
                                                  className={app === application ? 'tw-font-weight-strong' : ''}
                                              >
                                                  {app}
                                              </Link>
                                          </li>
                                      ))
                                    : null}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        )
    }

    private secondLine = (application: string | undefined, navigationContext: NavigationContext): string => {
        switch (navigationContext) {
            case 'user-settings':
            case 'organization-settings':
                return 'Settings'
            case 'dashboard':
                return 'Dashboard'
        }

        return application || 'Projects'
    }
}

export const OrganizationDropdown = connect(
    (state: ApplicationState): StateProps => {
        let organizations: string[] = []

        const { tidewaysContext } = state

        const loaded = getNavigationState(state).loaded

        if (loaded) {
            organizations = getNavigationState(state).organizations.map(org => org.name)
        }

        return {
            loaded,
            organizations,
            userName: tidewaysContext.router?.user?.displayName || 'unknown',
            defaultOrganization: tidewaysContext.router?.user?.defaultOrganization,
        }
    },
)(OrganizationDropdownComponent)
